import { render, staticRenderFns } from "./tzproduct7.vue?vue&type=template&id=72bb188f&scoped=true"
import script from "./tzproduct7.vue?vue&type=script&lang=js"
export * from "./tzproduct7.vue?vue&type=script&lang=js"
import style0 from "./tzproduct7.vue?vue&type=style&index=0&id=72bb188f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb188f",
  null
  
)

export default component.exports